/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Intro_EyebrowInputs */

const es_exp_mk_intro_eyebrow = /** @type {(inputs: Exp_Mk_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para todos`)
};

const gl_exp_mk_intro_eyebrow = /** @type {(inputs: Exp_Mk_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para todos`)
};

const en_exp_mk_intro_eyebrow = /** @type {(inputs: Exp_Mk_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For everyone`)
};

/**
* | output |
* | --- |
* | "For everyone" |
*
* @param {Exp_Mk_Intro_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_intro_eyebrow = /** @type {((inputs?: Exp_Mk_Intro_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Intro_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_intro_eyebrow(inputs)
	if (locale === "en") return en_exp_mk_intro_eyebrow(inputs)
	return es_exp_mk_intro_eyebrow(inputs)
});